import { API } from 'api';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { Flooding } from 'features/flooding/flooding.types';
import { LatLng, WithStringDates } from 'shared/types';
import { parseGeoEventDates } from 'features/geoEvents/geoEvent.utils';

export const fetchGeoEventsForAutocomplete = async (
  searchTerm: string = '',
  latLng?: LatLng,
  geoEventTypes?: string[],
  reporterManagedOnly?: boolean,
): Promise<(Wildfire | Flooding)[]> => {
  const types = geoEventTypes || ['wildfire'];
  const response = await API.get<{
    results: WithStringDates<Wildfire | Flooding>[];
  }>('geo_events/search/', {
    params: {
      q: searchTerm,
      ...(latLng ? { lat: latLng.lat, lng: latLng.lng } : {}),
      limit: 100,
      geoEventTypes: types.join(','),
      reporterManagedOnly: reporterManagedOnly ?? false,
      isActive: true,
    },
  });
  return response.data.results.map(parseGeoEventDates);
};
